import { render, staticRenderFns } from "./RingAuthorizationForm.vue?vue&type=template&id=e78dc80c&scoped=true&"
import script from "./RingAuthorizationForm.vue?vue&type=script&lang=js&"
export * from "./RingAuthorizationForm.vue?vue&type=script&lang=js&"
import style0 from "./RingAuthorizationForm.vue?vue&type=style&index=0&id=e78dc80c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78dc80c",
  null
  
)

export default component.exports